export default __webpack_public_path__ + "static/media/crops.c0e1048c.png";